import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, useLocation } from "react-router-dom";
import Routes from "./routes";
import "./assets/css/style.css";
import "./assets/css/lucid.css";

// เลื่อนหน้าขึ้นบนสุดทุกครั้งที่เปลี่ยน route
function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <ScrollToTop />
    <Routes />
  </BrowserRouter>
);
